import { useContext } from 'react';
import { Theme, makeStyles } from '@material-ui/core/styles';
import colorContext from '../../../../Context/colorContext';

export function useLocalizationStyles() {
    const { colors } = useContext(colorContext);
    const useStyles = makeStyles((theme: Theme) => ({
        main: {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '64px 0px',
            borderBottom: `1px solid ${colors.dividerColor}`,
            [theme.breakpoints.down('md')]: {
                padding: '64px 16px',
            },
        },
        content: {
            display: 'flex',
            maxWidth: '1040px',
            width: '100%',
            flexWrap: 'wrap',
            [theme.breakpoints.down('md')]: {
                flexDirection: 'column',
            },
            [theme.breakpoints.down('sm')]: {
                margin: '0px 0px',
                justifyContent: 'center',
            },
        },
        boxUnitysList: {
            marginRight: 24,
            [theme.breakpoints.down('md')]: {
                marginBottom: 24,
            },
            [theme.breakpoints.down('sm')]: {
                marginRight: 0,
            },
        },
        tag: {
            backgroundColor: colors.colorBackground,
            padding: '5px 12px',
            border: `1px solid ${colors.accentColor}`,
            borderRadius: 25,
            color: colors.accentColor,
            fontSize: theme.typography.pxToRem(13),
            fontWeight: 700,
            textTransform: 'uppercase',
            lineHeight: '20px',
            [theme.breakpoints.down('sm')]: {
                fontSize: theme.typography.pxToRem(11),
            },
        },
        labelText: {
            color: colors.textBody,
            fontWeight: 'normal',
            '&:hover': {
                color: colors.accentColor,
            },
        },
        textTitleSm: {
            fontWeight: 700,
            fontFamily: 'Open Sans',
            fontSize: theme.typography.pxToRem(24),
            color: colors.textBlackGray,
            marginBottom: 24,
            alignSelf: 'flex-start',
            width: '100%',
            display: 'none',
            [theme.breakpoints.down('md')]: {
                display: 'block',
            },
        },
        textTitle: {
            fontWeight: 700,
            fontFamily: 'Open Sans',
            fontSize: theme.typography.pxToRem(24),
            color: colors.textBlackGray,
            marginBottom: 32,
            alignSelf: 'flex-start',
            width: '100%',
            [theme.breakpoints.down('md')]: {
                display: 'none',
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: theme.typography.pxToRem(24),
                textAlign: 'center',
            },
        },
        subTitle: {
            fontSize: theme.typography.pxToRem(18),
            color: colors.subTitleColor,
            fontWeight: 400,
            lineHeight: '28.8px',
        },
        boxLocalizationSide: {
            flex: 1,
        },
        mainLocation: {
            margin: 24,
            width: '100%',
        },
        cardLocalization: {
            width: '100%',
            maxWidth: 688,
            borderRadius: 4,
            backgroundColor: colors.colorBackground,
            display: 'flex',
            flexDirection: 'column',
            boxShadow: colors.boxShadowColor,
            border: `1px solid ${colors.borderShadowsColor}`,
            [theme.breakpoints.down('sm')]: {
                maxWidth: '100%',
                marginTop: 10,
            },
        },
        boxLocalization: {
            height: 240,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: colors.serviceCardBackgroundColor,
        },
        localizationInfo: {
            padding: '24px 0px 39px 24px',
        },
        localeTitle: {
            fontWeight: 700,
            fontSize: theme.typography.pxToRem(24),
            marginBottom: 16,
            color: colors.textBody,
            [theme.breakpoints.down('sm')]: {
                fontSize: theme.typography.pxToRem(16),
            },
        },
        localizationSubTitle: {
            fontWeight: 400,
            fontSize: theme.typography.pxToRem(16),
            color: colors.textBody,
            marginBottom: 32,
            [theme.breakpoints.down('sm')]: {
                fontSize: theme.typography.pxToRem(13),
            },
        },
        day: {
            display: 'flex',
            justifyContent: 'space-between',
            backgroundColor: '#fff',
            padding: theme.spacing(0.5, 0),
        },
        details: {
            flexDirection: 'column',
            backgroundColor: '#fff',
            zIndex: 1000,
            [theme.breakpoints.down('xs')]: {
                paddingRight: '8px',
                paddingLeft: '8px',
            },
        },
        iconSize: {
            [theme.breakpoints.down('xs')]: {
                fontSize: '1rem',
            },
        },
        timeText: {
            margin: '0 8px',
            [theme.breakpoints.down('xs')]: {
                display: 'block',
            },
        },
        accordion: {
            width: 300,
            padding: '0 !important',
            boxShadow: colors.boxShadowColor,
            backgroundColor: '#F9F9F9',
            gap: 0,
            [theme.breakpoints.down('md')]: {
                width: '100%',
                marginBottom: 5,
            },
        },
        accordionDetails: {
            gap: 0,
            padding: 0,
            height: '100%',
            // maxHeight: 380,
            // overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
            // gap: 32,
            // padding: '24px 16px 24px 16px',
            // '&::-webkit-scrollbar': {
            //   width: 8,
            // },
            // '&::-webkit-scrollbar-thumb': {
            //   backgroundColor: colors.dividerColor,
            //   borderRadius: 24,
            // },
        },
        boxTitleUnits: {
            gap: 0,
            padding: '0 12px',
            backgroundColor: colors.colorBackground,
            borderTop: `2px solid ${colors.accentColor}`,
            borderBottom: `1px solid ${colors.dividerColor}`,
        },
        boxTitleExpanded: {},
        titleUnits: {
            color: colors.accentColor,
            fontWeight: 700,
            fontFamily: 'Open Sans',
            fontSize: theme.typography.pxToRem(16),
            [theme.breakpoints.down('sm')]: {
                fontSize: theme.typography.pxToRem(14),
            },
        },
        unityName: {
            fontSize: theme.typography.pxToRem(14),
            color: colors.textBody,
            fontWeight: 400,
            cursor: 'pointer',
            borderBottom: `1px solid ${colors.dividerColor}`,
            padding: 12,
            [theme.breakpoints.down('sm')]: {
                fontSize: theme.typography.pxToRem(14),
            },
        },
        selectedUnityName: {
            backgroundColor: colors.colorBackgroundSecundary,
            color: colors.textAccentColor,
            fontWeight: 600,
        },
        colorIcon: {
            color: colors.accentColor,
            fontSize: theme.typography.pxToRem(16),
        },
        radio: {
            color: colors.accentColor,
            '&.Mui-checked': {
                color: colors.accentColor,
            },
        },
        localizationContent: {
            flexDirection: 'row',
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column-reverse',
                justifyContent: 'center',
            },
        },
    }));
    const classes = useStyles();

    return {
        classes,
        colors,
    };
}